<template>
  <div v-if="disabled || truncate || active">
    <slot>
      <span>{{text}}</span>
    </slot>
  </div>
  <div v-else>
    <router-link v-if="changeRoute" :to="{ query: queryParams }" class="paginator-link">
      <slot>{{text}}</slot>
    </router-link>
    <a v-else @click="changePage" class="paginator-link" :class="{active: active}">
      <slot>{{text}}</slot>
    </a>
  </div>
</template>

<script>
export default {
  name: 'paginator-link',
  methods: {
    changePage() {
      this.$emit('change-page', this.queryParams);
    },
  },
  props: {
    page: Number,
    changeRoute: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    truncate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    text() {
      if (this.truncate) return '...';
      return this.page;
    },
    queryParams() {
      const query = this.changeRoute ? { ...this.$route.query } : {};
      if (this.page > 1) {
        query.page = this.page;
      } else {
        delete query.page;
      }
      return query;
    },
  },
};
</script>



// WEBPACK FOOTER //
// PaginatorLink.vue?715ba076